import React from "react";

import {
  propertViewOptions,
  flooringTypeOptions,
  electricityBackupOptions,
} from "../../constants";
import FeaturesIconMapping from "../../assets/icons/FeaturesIconMapping";
import CustomSvg from "../../shared/components/custom-svg/CustomSvg";

const formatIntoIconKey = (str) => {
  return str.replace(/[\s-]+/g, "_").toLowerCase();
};

function formatCamelCase(str) {
  // Convert camelCase to a more readable format (e.g., staffQuarters -> Staff Quarters)
  return str
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // Add space before uppercase letters
    .replace(/^./, (match) => match.toUpperCase()); // Capitalize the first letter
}

const featuresWithOptionsEnums = {
  BEDROOMS: "bedrooms",
  PROPERTY_VIEW: "propertyView",
  ELECTRICITY_BACKUP: "electricityBackup",
  FLOORING_TYPE: "flooringType",
};

const excludeProperties = ["featureIds", "id", "builtInYear"];

function filterAmenities(amenities) {
  return Object.entries(amenities)
    .filter(([key, value]) => {
      // Keep "bedrooms", "propertyView", "electricityBackup", and "flooringType" even if value is non-null
      return (
        value !== null &&
        value !== "" &&
        (value !== 0 ||
          [
            featuresWithOptionsEnums.BEDROOMS,
            featuresWithOptionsEnums.PROPERTY_VIEW,
            featuresWithOptionsEnums.ELECTRICITY_BACKUP,
            featuresWithOptionsEnums.FLOORING_TYPE,
          ].includes(key)) &&
        !(key === featuresWithOptionsEnums.ELECTRICITY_BACKUP && value === 1)
      );
    })
    .filter(([key]) => !excludeProperties.includes(key)) // Exclude "id" and "featureIds"
    .map(([key, value]) => {
      // Special handling for "bedrooms"
      if (key === featuresWithOptionsEnums.BEDROOMS) {
        if (value === 0) return { title: "Studio", icon: key }; // Studio case
        if (value === 10) return { title: "10+ Bedrooms", icon: key }; // 10+ Bedrooms case
        return { title: `${value} Bedrooms`, icon: key }; // Normal bedroom case
      }

      // Special handling for enums: propertyView, flooringType, electricityBackup
      if (
        key === featuresWithOptionsEnums.PROPERTY_VIEW &&
        propertViewOptions[value]
      ) {
        const updatedValue = `${propertViewOptions[value]} ${formatCamelCase(
          key
        )}`;
        return {
          title: updatedValue,
          icon: formatIntoIconKey(updatedValue),
        };
      }

      if (
        key === featuresWithOptionsEnums.FLOORING_TYPE &&
        flooringTypeOptions[value]
      ) {
        const updatedValue = `${flooringTypeOptions[value]} ${formatCamelCase(
          key
        )}`;
        return {
          title: updatedValue,
          icon: formatIntoIconKey(updatedValue),
        };
      }

      if (
        key === featuresWithOptionsEnums.ELECTRICITY_BACKUP &&
        electricityBackupOptions[value]
      ) {
        const updatedValue = `${
          electricityBackupOptions[value]
        } ${formatCamelCase(key)}`;
        return {
          title: updatedValue,
          icon: formatIntoIconKey(updatedValue),
        };
      }

      // Default case for other keys
      return { title: `${value} ${formatCamelCase(key)}`, icon: key };
    });
}

const PropertyFeatures = ({ amenities, features }) => {
  return (
    <div className="property-features-wrapper">
      <h2>Features</h2>
      <div className="property-features-grid">
        {[...filterAmenities(amenities), ...features]?.map((feature, index) => (
          <div key={index} className="property-feature-item">
            <div className="property-feature-icon">
              <CustomSvg
                src={FeaturesIconMapping[feature.icon]}
                className="property-details-feature-icon"
              />
            </div>
            <div
              className="property-feature-text text-ellipsis"
              title={feature.title}
            >
              {feature.title}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PropertyFeatures;
